import { isNil, omitBy } from 'lodash'

import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import {
  GetCatalogFacetedCategoriesArgs,
  GetCatalogFiltersArgs,
  GetCatalogInitializerArgs,
  GetCatalogItemsArgs,
  GetCatalogSearchedFiltersArgs,
  GetCatalogSearchScopeArgs,
} from '../types/dtos/api-arg'
import {
  BrandResp,
  GetCatalogFacetedCategoriesResp,
  GetCatalogFiltersFacetsResp,
  GetCatalogFiltersResp,
  GetCatalogInitializersResp,
  GetCatalogItemsResp,
  GetCatalogSearchedFiltersResp,
  GetCatalogSearchScopeResp,
  GetSessionDefaultsResp,
} from '../types/dtos/api-resp'
import {
  getCatalogFacetedCategoriesArgsToParams,
  getCatalogFiltersArgsToParams,
  getCatalogItemsArgsToParams,
  getCatalogSearchedFiltersArgsToParams,
} from '../transformers/api-transform'

export const getBrandById = (brandId: number) => api.get<BrandResp>(`/brands/${brandId}`)

export const getSessionDefaults = () =>
  api.get<GetSessionDefaultsResp>('/configurations/session_defaults')

export const getCatalogFacetedCategories = (args: GetCatalogFacetedCategoriesArgs) =>
  api.get<GetCatalogFacetedCategoriesResp>('/catalog/faceted_categories', {
    params: getCatalogFacetedCategoriesArgsToParams(args),
  })

export const getCatalogFiltersFacets = (args: GetCatalogFiltersArgs) =>
  api.get<GetCatalogFiltersFacetsResp>('/catalog/filters/facets', {
    params: getCatalogFiltersArgsToParams(args),
  })

export const getCatalogFilters = (args: GetCatalogFiltersArgs) =>
  api.get<GetCatalogFiltersResp>('/catalog/filters', {
    params: getCatalogFiltersArgsToParams(args),
  })

export const getCatalogInitializers = (args: GetCatalogInitializerArgs) =>
  api.get<GetCatalogInitializersResp>('/catalog/initializers', {
    params: omitBy(args, isNil),
    headers: moneyObjectHeader,
  })

export const getCatalogItems = (args: GetCatalogItemsArgs) =>
  api.get<GetCatalogItemsResp>('/catalog/items', {
    params: {
      ...getCatalogItemsArgsToParams(args),
      search_by_image_uuid: args.searchByImageUuid,
    },
    headers: moneyObjectHeader,
  })

export const getCatalogSearchScope = (args: GetCatalogSearchScopeArgs) =>
  api.get<GetCatalogSearchScopeResp>('/catalog/search_scope', {
    params: {
      search_text: args.searchText,
      catalog_id: args.catalogId,
      search_start_type: args.search_start_type,
      search_start_id: args.search_start_id,
    },
  })

export const getCatalogSearchedFilters = (args: GetCatalogSearchedFiltersArgs) =>
  api.get<GetCatalogSearchedFiltersResp>('/catalog/filters/search', {
    params: getCatalogSearchedFiltersArgsToParams(args),
  })
